<mbs-modal
  [title]="'shared:computers.addNewCompany' | i18next"
  [attr.data-e2e]="e2eLocators.main"
  #modal>
  <ng-container modal-body>
    <form
      [formGroup]="modalForm"
      class="mbs-form_content mb-3">
      <mbs-input
        formControlName="companyName"
        [attr.data-e2e]="e2eLocators.companyNameControl"
        [showRequiredMark]="false"
        [label]="'shared:computers.companyName' | i18next"
        [placeholder]="'shared:computers.addNewCompanyInputPlaceholder' | i18next"
        [validationWhitespace]="true"></mbs-input>
    </form>

    <mbs-info-card>
      <div class="d-flex flex-column">
        <span class="fw-bold">{{ 'shared:alerts.tryTemplate' | i18next }}</span>
        <span class="text-sm">
          <span>{{ 'shared:alerts.tryTemplateDesc' | i18next }}</span>
          <mbs-button
            (click)="goToTemplateClickHandler()"
            [isCtrl]="true"
            >{{ 'shared:alerts.selectTemplate' | i18next }}</mbs-button
          >
        </span>
      </div>
    </mbs-info-card>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="onCreateCompanyButtonClick()"
      [attr.data-e2e]="e2eLocators.createBtn"
      [loading]="requestInProgress">
      {{ 'shared:buttons.create' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
